import React, { CSSProperties } from 'react';
import Ratio from 'react-ratio';
import { isMobile } from 'react-device-detect';
import { MediaQuery } from '../Common';
import images from '../../assets';
import CartBtn from './cartBtn';
import LikeBtn from './LikeBtn';

const RadioArea = ({ children, bg, style, onEnter, onLeave }) => {
  return (
    <>
      <MediaQuery min={1200}>
        <Ratio
          ratio={1}
          style={{
            ...rootstyle,
            width: 'calc(20% - 20px)',
            margin: 10,
            backgroundImage: `url(${bg})`,
            ...style,
          }}
          onMouseEnter={onEnter}
          onMouseLeave={onLeave}
        >
          {children}
        </Ratio>
      </MediaQuery>
      <MediaQuery max={1199}>
        <MediaQuery min={1000}>
          <Ratio
            ratio={1}
            style={{
              ...rootstyle,
              width: 'calc(25% - 20px)',
              margin: 10,
              backgroundImage: `url(${bg})`,
              ...style,
            }}
            onMouseEnter={onEnter}
            onMouseLeave={onLeave}
          >
            {children}
          </Ratio>
        </MediaQuery>
        <MediaQuery max={999}>
          <MediaQuery min={700}>
            <Ratio
              ratio={1}
              style={{
                ...rootstyle,
                width: 'calc(33% - 20px)',
                margin: 10,
                backgroundImage: `url(${bg})`,
                ...style,
              }}
              onMouseEnter={onEnter}
              onMouseLeave={onLeave}
            >
              {children}
            </Ratio>
          </MediaQuery>
          <MediaQuery max={699}>
            <Ratio
              ratio={1}
              style={{
                ...rootstyle,
                width: 'calc(50% - 20px)',
                margin: 10,
                backgroundImage: `url(${bg})`,
                ...style,
              }}
              onMouseEnter={onEnter}
              onMouseLeave={onLeave}
            >
              {children}
            </Ratio>
          </MediaQuery>
        </MediaQuery>
      </MediaQuery>
    </>
  );
};

class DesignThum extends React.Component {
  state = {
    showinfo: false,
  };

  onOffLike = () => {
    const { remove } = this.state;
    this.setState({ remove: !remove });
  }

  render() {
    const {
      bg,
      onFavClick,
      onBasket,
      onClick,
      onRemove,
      remove = false,
      like = false,
      style,
      license,
      name,
      designerName,
      onDesigner,
      productId,
      ShowBasketModal,
      is_in_cart,
      setCartInOut
    } = this.props;
    const { showinfo } = this.state;
    return (
      <RadioArea
        ratio={1}
        bg={bg}
        style={style}
        onEnter={() => {
          this.setState({ showinfo: true });
        }}
        onLeave={() => {
          this.setState({ showinfo: false });
        }}
      >
        <div
          style={{
            position: 'absolute',
            left: 0,
            top: 35,
            width: '100%',
            height: '70%',
            zIndex: 9,
            cursor: 'pointer',
          }}
          onClick={() => {
            if (!remove && !showinfo) {
              this.setState({ showinfo: true });
            } else {
              onClick();
            }
          }}
        />
        {isMobile && showinfo && (
          <div
            style={{
              ...topstyle,
              backgroundColor: !remove || Boolean(onRemove) ? 'rgb(0, 0, 0, 0.8)' : '',
            }}
          >
            <div style={preminumtext}>{license}</div>
            {Boolean(onRemove) && (
              <div style={{ position: 'absolute', top: 8, right: 5 }} onClick={onRemove}>
                <img alt="" src={images.icon_close_ph} />
              </div>
            )}
          </div>
        )}
        {/* {isMobile && Boolean(onRemove) && (
          <div
            style={{
              ...bottomstyle,
              backgroundColor: remove ? 'rgb(255, 138, 6, 0.9)' : 'rgb(0, 0, 0, 0.8)',
              padding: 0,
              height: 35,
            }}
          >
            <div style={{position: 'absolute', bottom: 5, right: 10}} onClick={onRemove}>
              <img alt='' src={images.icon_close_ph} />
            </div>
          </div>
        )} */}
        {!isMobile && showinfo && (
          <>
            <div
              style={{
                ...topstyle,
                backgroundColor: remove ? 'rgb(255, 138, 6, 0.9)' : 'rgb(0, 0, 0, 0.8)',
              }}
            >
              <div style={preminumtext}>{license}</div>
              
              <CartBtn preminumimg={preminumimg} remove={remove} productId={productId} ShowBasketModal={ShowBasketModal} is_in_cart={is_in_cart} setCartInOut={setCartInOut}/>
              <LikeBtn preminumimg={preminumimg} onFavClick={onFavClick} onRemove={onRemove} like={like} remove={remove} onOffLike={this.onOffLike} productId={productId}/>
              {/* <div style={{ ...preminumimg, marginRight: 16 }} onClick={onFavClick}>
                {!remove ? (
                  <img alt="" src={like ? images.icon_liked : images.icon_favori_rmv} />
                ) : (
                  <img alt="" src={like ? images.icon_black_liked : images.icon_favori_rmv} />
                )}
              </div> */}
            </div>
            <div
              style={{
                ...bottomstyle,
                backgroundColor: remove ? 'rgb(255, 138, 6, 0.9)' : 'rgb(0, 0, 0, 0.8)',
              }}
            >
              <div style={bottomtitle}>{name}</div>
              <div style={bottomdesigner} onClick={onDesigner}>
                by {designerName}
              </div>
              {Boolean(onRemove) && (
                <div
                  style={{
                    position: 'absolute',
                    bottom: 10,
                    right: 10,
                    zIndex: '10',
                  }}
                  onClick={onRemove}
                >
                  <img alt="" src={images.icon_close_fv} />
                </div>
              )}
            </div>
          </>
        )}
      </RadioArea>
    );
  }
}

const rootstyle: CSSProperties = {
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  marginBottom: '1.5vw',
  position: 'relative',
};

const topstyle: CSSProperties = {
  height: 36,
  width: '100%',
  display: 'flex',
  alignItems: 'center',
};

const preminumtext: CSSProperties = {
  flex: 1,
  color: 'white',
  fontSize: 14,
  fontFamily: 'NSCJKrM',
  marginLeft: 16,
  lineHeight: '36px',
};

const preminumimg: CSSProperties = {
  cursor: 'pointer',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: 36,
  zIndex: 99,
};

const bottomstyle: CSSProperties = {
  width: '100%',
  position: 'absolute',
  bottom: 0,
  left: 0,
  paddingTop: 16,
  paddingBottom: 16,
  cursor: 'pointer',
};

const bottomtitle: CSSProperties = {
  fontFamily: 'NSCJKrB',
  fontSize: 16,
  color: 'white',
  lineHeight: '16px',
  marginLeft: 16,
  marginRight: 16,
  marginBottom: 12,
};

const bottomdesigner: CSSProperties = {
  fontFamily: 'NSCJKrR',
  fontSize: 14,
  color: 'white',
  lineHeight: '16px',
  marginLeft: 16,
  marginRight: 16,
};

export default DesignThum;
